module.exports = __webpack_public_path__ + "img/serviceTakeback-step3@2x.7af80fc6.png";